import styled from 'styled-components'
import {
  borderColor,
  BorderColorProps,
  flexDirection,
  FlexDirectionProps,
} from 'styled-system'

import { DIV_SHOULD_FORWARD_PROP } from 'Config/shouldForwardProp'

import { gap, GapProps } from 'Services/Styles'

const shouldForwardProp = (prop: string | number) => {
  return !DIV_SHOULD_FORWARD_PROP.includes(String(prop))
}

export const Content = styled.div.withConfig({
  shouldForwardProp,
})<FlexDirectionProps & GapProps>`
  display: flex;
  width: 100%;

  ${flexDirection}
  ${gap}
`

export const LegendHolder = styled.div.withConfig({
  shouldForwardProp,
})<FlexDirectionProps & GapProps>`
  display: flex;
  min-width: 310px;
  flex-grow: 1;
  flex-wrap: wrap;
  justify-content: center;

  ${flexDirection}
  ${gap}
`

export const LegendItemPoint = styled.div.withConfig({
  shouldForwardProp,
})<BorderColorProps>`
  width: 0;
  height: 0;
  border-width: 6px;
  border-style: solid;
  border-radius: 6px;

  ${borderColor}
`

export const SvgHolder = styled.div`
  width: 100%;
  max-width: 1100px;
  max-height: 440px;

  svg {
    height: 100%;
    width: 100%;
  }
`
